import { LDClient, LDFlagSet } from 'launchdarkly-js-client-sdk'

import { FeatureFlags } from './FeatureFlags.enum'

export const DEFAULT_FLAGS: LDFlagSet = {
  [FeatureFlags.EnableEncryption]:
    process.env.NODE_ENV === 'production' ? true : false,
  [FeatureFlags.SampleFeature]: false,
}

let ldClient: LDClient | null = null

export function setLDClient(client: LDClient) {
  ldClient = client
}

export function getFeatureFlag(key: FeatureFlags) {
  if (ldClient) {
    return ldClient.variation(key, DEFAULT_FLAGS[key])
  }
  return DEFAULT_FLAGS[key]
}

export function getFeatureFlags() {
  if (ldClient) {
    return ldClient.allFlags()
  }
  return DEFAULT_FLAGS
}
